import { render, staticRenderFns } from "./Bookface.vue?vue&type=template&id=09b3c955&scoped=true&"
import script from "./Bookface.vue?vue&type=script&lang=js&"
export * from "./Bookface.vue?vue&type=script&lang=js&"
import style0 from "./Bookface.vue?vue&type=style&index=0&id=09b3c955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3c955",
  null
  
)

export default component.exports